import { render, staticRenderFns } from "./impersonate.vue?vue&type=template&id=298f1bc8&scoped=true&"
import script from "./impersonate.vue?vue&type=script&lang=ts&"
export * from "./impersonate.vue?vue&type=script&lang=ts&"
import style0 from "./impersonate.vue?vue&type=style&index=0&id=298f1bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f1bc8",
  null
  
)

export default component.exports